import { z } from 'zod'
import noLeadingSpaces from '../../../utilities/noLeadingSpaces'

export const registrationSchema = z.object({
  first_name: z
    .string()
    .min(1, 'First name is required')
    .max(15, 'First name should be at most 15 characters long')
    .refine(noLeadingSpaces, { message: 'Leading spaces are not allowed' }),

  last_name: z
    .string()
    .min(1, 'Last name is required')
    .max(15, 'Last name should be at most 15 characters long')
    .refine(noLeadingSpaces, { message: 'Leading spaces are not allowed' }),

  email: z
    .string()
    .min(5, { message: 'Email is required' })
    .refine(noLeadingSpaces, { message: 'Leading spaces are not allowed' })
    .refine((value) => /^[\w-.+]+@([\w-]+\.)+[\w-]{2,4}$/.test(value), {
      message: 'Invalid email format.',
    }),

  phone_number: z
    .string()
    .nullable()
    .transform((value) => (value === null ? '' : value))
    .refine(
      (value) => {
        return (
          (/^\d{10}$/.test(value) &&
            parseInt(value, 10) !== 0 &&
            !/\+/.test(value)) ||
          value === ''
        )
      },
      {
        message: 'Enter a Valid 10-digit Mobile Number',
      }
    ),
  message: z
    .string()
    .min(1, 'Message is required')
    .refine(noLeadingSpaces, { message: 'Leading spaces are not allowed' }),
})

export type RegistrationSchema = z.infer<typeof registrationSchema>
